(function () {
  'use strict';

  // ---- Menú móvil (cajón lateral) ----
  var drawer = document.querySelector('[data-drawer]');
  var scrim = document.querySelector('.scrim');
  function openDrawer() {
    if (!drawer) return;
    if (scrim) { scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-on'); }); }
    drawer.classList.add('is-on');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-on');
    if (scrim) {
      scrim.classList.remove('is-on');
      setTimeout(function () { scrim.hidden = true; }, 240);
    }
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); openDrawer(); }
    else if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // ---- Fecha de entrega estimada (7-12 días laborables, saltando fines de semana) ----
  var meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  function masLaborables(n) {
    var d = new Date();
    while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
    return d;
  }
  var dMin = masLaborables(7), dMax = masLaborables(12);
  var txt = dMin.getMonth() === dMax.getMonth()
    ? dMin.getDate() + ' y el ' + dMax.getDate() + ' de ' + meses[dMax.getMonth()]
    : dMin.getDate() + ' de ' + meses[dMin.getMonth()] + ' y el ' + dMax.getDate() + ' de ' + meses[dMax.getMonth()];
  document.querySelectorAll('[data-fecha]').forEach(function (el) { el.textContent = txt; });

  // ---- Galería del producto ----
  var slides = document.querySelectorAll('.gal-slide');
  var thumbs = document.querySelectorAll('.thumb');
  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      t.setAttribute('aria-current', 'true');
      slides.forEach(function (s) {
        var on = s.dataset.slide === t.dataset.slide;
        s.classList.toggle('is-on', on);
        var v = s.querySelector('video');
        if (v) {
          if (on) { v.play().catch(function () {}); }
          else { v.pause(); }
        }
      });
    });
  });


  // ---- Carrusel ----
  document.querySelectorAll('[data-carousel]').forEach(function (car) {
    var sec = car.closest('section');
    var prev = sec && sec.querySelector('[data-car-prev]');
    var next = sec && sec.querySelector('[data-car-next]');
    function step() {
      var card = car.querySelector('.collab');
      var gap = parseFloat(getComputedStyle(car).gap) || 20;
      return card ? card.getBoundingClientRect().width + gap : car.clientWidth * 0.8;
    }
    function sync() {
      if (!prev || !next) return;
      prev.disabled = car.scrollLeft <= 4;
      next.disabled = car.scrollLeft + car.clientWidth >= car.scrollWidth - 4;
    }
    if (prev) prev.addEventListener('click', function () { car.scrollBy({ left: -step() }); });
    if (next) next.addEventListener('click', function () { car.scrollBy({ left: step() }); });
    car.addEventListener('scroll', sync, { passive: true });
    sync();
  });


  // ---- Localiza tu paquete ----
  var trackForm = document.querySelector('[data-track]');
  if (trackForm) {
    var TRACKER = 'https://www.17track.net/es/track?nums=';
    var numEl = trackForm.querySelector('[data-track-number]');
    var msg = trackForm.querySelector('[data-track-msg]');
    var alt = trackForm.querySelector('[data-track-alt]');

    function clean(v) { return (v || '').trim().replace(/\s+/g, ''); }

    if (numEl && alt) {
      numEl.addEventListener('input', function () {
        alt.href = TRACKER + encodeURIComponent(clean(numEl.value));
      });
    }

    trackForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var num = clean(numEl.value);
      if (!num) {
        msg.innerHTML = 'Escribe el número de seguimiento. Te llega por <strong>email</strong> cuando el paquete sale del almacén.';
        msg.style.color = 'var(--accent)';
        numEl.focus();
        return;
      }
      msg.innerHTML = 'Buscando <strong>' + num + '</strong>. Te abrimos el seguimiento en una pestaña nueva.';
      msg.style.color = 'var(--good)';
      window.open(TRACKER + encodeURIComponent(num), '_blank', 'noopener');
    });
  }


  // ---- Cesta: pasamos las instrucciones del repartidor a la nota ----
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var noteEl = cartForm.querySelector('[data-note]');
    var extraEl = cartForm.querySelector('[data-note-extra]');
    cartForm.addEventListener('submit', function () {
      if (!noteEl) return;
      var extra = extraEl && extraEl.value.trim();
      noteEl.value = extra ? ('Instrucciones: ' + extra) : '';
    });
  }

  // ---- Asistente de ayuda ----
  var bot = document.querySelector('[data-bot]');
  if (bot) {
    var panel = bot.querySelector('[data-bot-panel]');
    var body = bot.querySelector('[data-bot-body]');
    bot.querySelectorAll('[data-bot-toggle]').forEach(function (b) {
      b.addEventListener('click', function () {
        var open = bot.classList.toggle('is-on');
        panel.hidden = !open;
        bot.querySelector('[data-bot-toggle]').setAttribute('aria-expanded', String(open));
      });
    });
    bot.querySelectorAll('.bot-opt').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var q = document.createElement('div');
        q.className = 'bot-msg bot-out';
        q.textContent = opt.textContent;
        body.appendChild(q);
        body.scrollTop = body.scrollHeight;
        setTimeout(function () {
          var a = document.createElement('div');
          a.className = 'bot-msg bot-in';
          a.textContent = opt.dataset.answer;
          body.appendChild(a);
          body.scrollTop = body.scrollHeight;
        }, 320);
      });
    });
  }


  // ---- Puntuación con estrellas ----
  document.querySelectorAll('[data-starpick]').forEach(function (pick) {
    var stars = pick.querySelectorAll('.sp');
    var val = pick.querySelector('[data-starval]');
    function paint(n) {
      stars.forEach(function (s, i) { s.classList.toggle('on', i < n); });
    }
    stars.forEach(function (s) {
      s.addEventListener('click', function () {
        val.value = s.dataset.v;
        paint(parseInt(s.dataset.v, 10));
      });
      s.addEventListener('mouseenter', function () { paint(parseInt(s.dataset.v, 10)); });
    });
    pick.addEventListener('mouseleave', function () { paint(parseInt(val.value, 10)); });
    paint(parseInt(val.value, 10) || 5);
  });


  // ---- Combínalo: recomendaciones automáticas de Shopify ----
  var reco = document.querySelector('[data-recos]');
  if (reco && reco.dataset.url && reco.dataset.product) {
    var url = reco.dataset.url + '?section_id=' + reco.dataset.section +
              '&product_id=' + reco.dataset.product +
              '&limit=' + (reco.dataset.limit || 4);
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recos-grid]');
        var here = reco.querySelector('[data-recos-grid]');
        if (fresh && here && fresh.children.length > 0) { here.innerHTML = fresh.innerHTML; }
      })
      .catch(function () { /* se queda lo que ya venía del servidor */ });
  }

  // ---- Selector de variantes ----
  var root = document.querySelector('[data-product]');
  var json = document.querySelector('[data-variants]');
  if (!root || !json) return;

  var variants = JSON.parse(json.textContent);
  var idInput = root.querySelector('[data-variant-id]');
  var addBtn = root.querySelector('[data-add]');
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');
  var ctaPrice = root.querySelector('[data-cta-price]');

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function selected() {
    return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (blk) {
      var on = blk.querySelector('.opt[aria-pressed="true"]');
      return on ? on.dataset.value : null;
    });
  }

  function update() {
    var sel = selected();
    var match = variants.find(function (v) {
      return sel.every(function (val, i) { return val === null || v.options[i] === val; });
    });

    root.querySelectorAll('[data-option-index]').forEach(function (blk, i) {
      var cur = blk.querySelector('[data-option-current]');
      if (cur && sel[i]) { cur.textContent = sel[i]; }
    });

    if (!match) return;
    if (idInput) { idInput.value = match.id; }
    if (priceEl) { priceEl.textContent = money(match.price); }
    if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = money(match.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (ctaPrice) { ctaPrice.textContent = money(match.price); }
    if (addBtn) {
      addBtn.disabled = !match.available;
      if (!match.available) { addBtn.textContent = 'Agotado'; }
    }
    if (history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      history.replaceState({}, '', url.toString());
    }
  }

  root.querySelectorAll('.opts').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var b = e.target.closest('.opt');
      if (!b || b.disabled) return;
      group.querySelectorAll('.opt').forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      update();
    });
  });
})();


(function(){
  // ---- Extras de la cesta ----
  var upsell = document.querySelector('.upsell');
  if (!upsell) return;

  function say(msg){
    var w = upsell.querySelector('[data-upsell-err]');
    if (!w) return;
    w.textContent = msg || '';
    w.hidden = !msg;
  }

  upsell.addEventListener('change', function (e) {
    var box = e.target.closest('[data-upsell]');
    if (!box) return;
    var id = box.dataset.upsell;
    if (!id) return;

    if (upsell.classList.contains('is-busy')) { box.checked = !box.checked; return; }
    upsell.classList.add('is-busy');
    say('');

    var req;
    if (box.checked) {
      // add.js: /cart/update.js NO puede añadir una variante que no esté ya en la cesta (422)
      req = fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
    } else {
      req = fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(id), quantity: 0 })
      });
    }

    req
      .then(function (r) {
        if (!r.ok) { return r.text().then(function (t) { throw new Error(t); }); }
        window.location.reload();
      })
      .catch(function () {
        upsell.classList.remove('is-busy');
        box.checked = !box.checked;
        say('No hemos podido actualizar la cesta. Inténtalo otra vez.');
      });
  });
})();


/* r23: código de descuento en la cesta */
(function () {
  var box = document.querySelector('[data-dcto]');
  if (!box) return;
  var msg = box.querySelector('[data-dcto-msg]');
  var busy = false;

  function say(t, ok) {
    if (!msg) return;
    msg.textContent = t || '';
    if (ok) { msg.classList.add('ok'); } else { msg.classList.remove('ok'); }
    msg.hidden = !t;
  }

  function attrs() {
    var a = {};
    var t1 = document.querySelector('[data-tel1]');
    var t2 = document.querySelector('[data-tel2]');
    if (t1) a['Teléfono principal'] = t1.value || '';
    if (t2) a['Teléfono secundario'] = t2.value || '';
    return a;
  }

  function found(c) {
    var n = (c.cart_level_discount_applications || []).length;
    (c.items || []).forEach(function (i) { n += (i.discounts || []).length; });
    return n;
  }

  function reset(go) {
    busy = false;
    if (go) { go.disabled = false; go.textContent = 'Aplicar'; }
  }

  function send(code) {
    if (busy) return;
    busy = true;
    var go = box.querySelector('[data-dcto-go]');
    if (go) { go.disabled = true; go.textContent = 'Aplicando…'; }
    say('');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code, attributes: attrs() })
    })
      .then(function () { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }); })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (code && !found(c)) {
          reset(go);
          say('Ese código no se puede aplicar a tu cesta. Comprueba que está bien escrito y que llegas al pedido mínimo.');
          return;
        }
        window.location.reload();
      })
      .catch(function () {
        reset(go);
        say('No se ha podido conectar. Inténtalo otra vez.');
      });
  }

  box.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-dcto-open]')) {
      var row = box.querySelector('[data-dcto-row]');
      var op = box.querySelector('[data-dcto-open]');
      if (row) row.hidden = false;
      if (op) op.hidden = true;
      var inp = box.querySelector('[data-dcto-in]');
      if (inp) inp.focus();
      return;
    }
    if (t.closest('[data-dcto-go]')) {
      var i = box.querySelector('[data-dcto-in]');
      var v = i ? i.value.trim() : '';
      if (!v) { say('Escribe un código.'); if (i) i.focus(); return; }
      send(v);
      return;
    }
    if (t.closest('[data-dcto-del]')) { send(''); }
  });

  box.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-dcto-in]')) return;
    e.preventDefault();
    var v = t.value.trim();
    if (!v) { say('Escribe un código.'); return; }
    send(v);
  });
})();
